module.exports = __webpack_public_path__ + "img/jch1.d92a2428.jpg";